import { render } from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=template&id=d0b6e458"
import script from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=script&lang=js"
export * from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__